/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { miscGetMiscDistrict } from "../../funcs/miscGetMiscDistrict.js";
import { GetMiscDistrictRequest$zodSchema } from "../../models/getmiscdistrictop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: GetMiscDistrictRequest$zodSchema.optional(),
};

export const tool$miscGetMiscDistrict: ToolDefinition<typeof args> = {
  name: "misc-get-misc-district",
  description: `Adcode 国内外行政区域查询

一个接口，覆盖全球 243 个国家、中国省/市/区/街道四级行政区划，支持关键词搜索、行政编码查询、坐标反查三种查询模式（必须至少传入一种查询参数）。

## 功能概述
根据用户输入的搜索条件快速查找行政区域信息。例如：中国 > 山东省 > 济南市 > 历下区 > 舜华路街道。

无需注册、无需密钥，直接调用即可获取结构化的行政区域数据。支持三种查询方式：
- 传 \`adcode\`，按行政编码精确查询，同时返回下级区划列表
- 传 \`lat\` + \`lng\`，坐标反查附近地点
- 传 \`keywords\`，按关键词搜索，支持中英文

## 中国与国际数据差异
中国数据包含 \`adcode\`、\`citycode\` 等字段，支持省/市/区/街道四级逐级查询；国际城市数据不含这些字段，但额外提供 \`population\`（人口）和 \`timezone\`（时区）。

> [!NOTE]
> 部分城市（如东莞、文昌）没有区县层级，市级下方直接显示街道。街道级别的 \`adcode\` 返回的是所属区县的 \`adcode\`。`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await miscGetMiscDistrict(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
